export function isoTimestampToReadableDate(isoTimestamp) {
    const date = new Date(isoTimestamp);

    const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: undefined, // Omit seconds for simplicity
        hour12: true,      // Use 12-hour format
    };

    return  date.toLocaleString("en-US", options);

}

export function isoTimestampToReadableDateOnly(isoTimestamp) {
    const date = new Date(isoTimestamp);

    const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: undefined,
        minute: undefined,
        second: undefined, // Omit seconds for simplicity
        hour12: true,      // Use 12-hour format
    };

    return  date.toLocaleString("en-US", options);

}

export function isDateInCurrentWeek(dateString) {
    const date = new Date(dateString);
    const now = new Date();

    // Get the start of the current week (Sunday)
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay());
    startOfWeek.setHours(0, 0, 0, 0);

    // Get the end of the current week (Saturday)
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    endOfWeek.setHours(23, 59, 59, 999);

    return date >= startOfWeek && date <= endOfWeek;
}

export function isDateInCurrentMonth(dateString) {
    const date = new Date(dateString);
    const now = new Date();

    return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth();
}